
// Google Maps API configuration
export const GOOGLE_MAPS_CONFIG = {
  apiKey: 'AIzaSyBV0ysXKvwCtxAKm6GGRI2pQy-jP9sH8lg',
  defaultZoom: 15,
  mapOptions: {
    gestureHandling: 'cooperative' as const,
    disableDefaultUI: false,
  }
};
